export default {
  institution: 'Institution',
  configurationAndInstitutionalData: 'Configuration and institutional data',
  changeLogo: 'Change Logo',
  uploadLogo: 'Upload Logo',
  gradingSystem: 'Grading System',
  gradesAndEvaluationsConfiguration: 'Grades and evaluations configuration',
  minGrade: 'Minimum Grade',
  passingGrade: 'Passing Grade',
  maxGrade: 'Maximum Grade',
  exigencePercentage: 'Requirement Percentage',
  gradeLockedMessage: 'Currently the {gradeType} is locked, please contact an Administrator',
  mustBeGreaterThanOrEqualToZero: 'Must be greater than or equal to zero',
  cannotBeGreaterThanOrEqualToPassingGrade: 'Cannot be greater than or equal to the Passing Grade',
  cannotBeGreaterThanMaxGrade: 'Cannot be greater than the Maximum Grade',
  cannotBeLessThanPassingGrade: 'Cannot be less than the Passing Grade',
  cannotBeLessThanMinGrade: 'Cannot be less than the Minimum Grade',
  exigencePercentageTooltip: 'Requirement percentage needed for an Evaluation to be graded with the passing grade',
  mustBeBetweenZeroAndHundred: 'Must be greater than or equal to 0 and less than or equal to 100',
  academicSystem: 'Academic System',
  creditsAndSchedulesConfiguration: 'Credits and schedules configuration',
  hoursPerSCTCredit: 'Hours per SCT Credit',
  hoursPerCreditTooltip: 'Value by which Total Pedagogical Hours is divided to determine the amount of SCT Credit',
  minutesPerPedagogicalHour: 'Minutes per Pedagogical Hour',
  minutesPerHourTooltip: 'Value used for converting pedagogical hours to chronological hours in Subjects that do not have an associated Graduation Profile',
  mustBeGreaterThanOrEqualToOne: 'Must be greater than or equal to 1',
  saveChanges: 'Save Changes',
  selectImage: 'Select Image',
  institutionUpdated: 'Institution Updated',
  institutionLogoDeleted: 'Institution Logo Deleted',
  institutionLogoUpdated: 'Institution Logo Updated',
}
